"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedUser = void 0;
class AuthenticatedUser {
    constructor(user) {
        this.user = user;
    }
    static initialValue() {
        return new AuthenticatedUser({});
    }
    get id() {
        return parseInt(this.user.sub);
    }
    get displayName() {
        return this.user.name;
    }
    hasAccessTo(claim) {
        if (!this.user) {
            return false;
        }
        return this.user["access"]
            .split(",")
            .map((i) => i.toLowerCase())
            .includes(claim.toLowerCase());
    }
}
exports.AuthenticatedUser = AuthenticatedUser;
